module.exports = __webpack_public_path__ + "img/060-webpage-3.c0d49606.svg";